module.exports = __webpack_public_path__ + "static/yyk-579f0f014f0894851aba129f4036318d.jpg";